import CommonPage from "../../components/CommonPage/CommonPage";

export default CommonPage;
